<div class="row align-items-center"
  style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
  <div class="col">
    <div class="eventsheader">Event Details</div>
  </div>
</div>

<div style="background-color: rgb(241, 235, 228); padding-bottom:10px">
<form [formGroup]="eventForm">
  <div class="container ">
    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field  appearance="outline">
            <mat-label>Event Name*</mat-label>
            <input readonly  matInput formControlName="EventName">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Event Organizer</mat-label>
            <input readonly matInput formControlName="organizerName">
          </mat-form-field>
        </div>
        <div class="row">
          <mat-checkbox disabled [checked]="eventDetails.id" class="example-margin" formControlName="isRecurring">Recurring Event</mat-checkbox>

        </div>
        <!-- <div class="row">
          <mat-form-field>
            <input readonly matInput [ngxMatDatetimePicker]="pickerStart" placeholder={{eventDetails.event_dates[0].date}} [formControl]="dateControl"
              [min]="minDate" [max]="maxDate" [disabled]="disabled" formControlName="startDate">
            <mat-datepicker-toggle disabled matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #pickerStart [showSpinners]="showSpinners" [stepHour]="stepHour"
              [stepMinute]="stepMinute" [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian"
              [disableMinute]="disableMinute" [hideTime]="hideTime">
            </ngx-mat-datetime-picker>
          </mat-form-field>

          <mat-form-field>
            <input readonly matInput [ngxMatDatetimePicker]="pickerEnd" placeholder={{eventDetails.event_dates[lastIndex].date}} [formControl]="dateControl"
              [min]="minDate" [max]="maxDate" [disabled]="disabled" formControlName="endDate">
            <mat-datepicker-toggle disabled matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #pickerEnd [showSpinners]="showSpinners" [stepHour]="stepHour"
              [stepMinute]="stepMinute" [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian"
              [disableMinute]="disableMinute" [hideTime]="hideTime">
            </ngx-mat-datetime-picker>
          </mat-form-field>

        </div> -->

        <div  class="row">

          <mat-form-field *ngIf="recurring" >
            <mat-label>Choose date range</mat-label>
            <mat-date-range-input [formGroup]="rangeDate">
              <input readonly formControlName="start" matStartDate>
              <input readonly formControlName="end" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle disabled matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker disabled #picker></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field *ngIf="!recurring">
            <mat-label>Choose a date</mat-label>
            <input readonly formControlName="date" matInput>
            <mat-datepicker-toggle disabled matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled #picker></mat-datepicker>
          </mat-form-field>


          

              <!-- https://www.npmjs.com/package/ng2-timepicker -->
    <mat-form-field>
      <mat-label>Start Time</mat-label>
      <input readonly style="cursor: pointer;" placeholder="HH:MM" matInput formControlName="start_time"/>
    </mat-form-field>
    <!-- <ngx-material-timepicker #pickerTimeStart></ngx-material-timepicker> -->

    <mat-form-field>
      <mat-label>End Time</mat-label>
      <input readonly style="cursor: pointer;" placeholder="HH:MM" matInput formControlName="end_time"/>
    </mat-form-field>

        </div>

        <div class="row">
          <mat-card style="width: 100%;">
            <label>Category*</label>
            <br>
            <mat-chip-list #chipList [multiple]="true" [selectable]="true">
              <mat-chip  *ngFor="let category of categories" #chip="matChip" 
                (click)="category.selected ? chip.deselect() : chip.selectViaInteraction()"
                [selected]="category.selected" [selectable]="true" class="leadr-category-chip"
                (selectionChange)="changeSelected($event, category)">
                {{category.name}}
              </mat-chip>
            </mat-chip-list>
          </mat-card>
        </div>

        <div class="mapdiv">
          <mat-form-field style="width: 100%; margin-top: 10px;" appearance="outline">
            <mat-label>Address*</mat-label>
            <input readonly matInput formControlName="Address">
          </mat-form-field>
          <agm-map [latitude]="eventDetails.location_lat" [longitude]="eventDetails.location_lng" [zoom]="12">
            <agm-marker [latitude]="eventDetails.location_lat" [longitude]="eventDetails.location_lng"></agm-marker>
          </agm-map>
  
        </div>

        <!-- <div class="row">
          <mat-card style="width: 100%">
            <label>Fees</label>
            <br>
            <mat-form-field class="fees" appearance="outline">
              <mat-label>Minimum Fee</mat-label>
              <input readonly matInput formControlName="minFee">
            </mat-form-field>

            <mat-form-field class="fees" appearance="outline">
              <mat-label>Maximum Fee</mat-label>
              <input readonly matInput formControlName="maxFee">
            </mat-form-field>
            <label class="fixedpricehint">If you have only one ticket price please input both fields as the same number</label>
          </mat-card>
        </div> -->

        <div class="row">
          <mat-card>
            <label>Fees*</label><br>
            <input readonly matInput formControlName="eventFee">
            <br>
            <!-- <label class="fixedpricehint">If your event is paid please provide the fees in the description
              below</label> -->
          </mat-card>
        </div>


        <div class="row">
          <mat-form-field style="width: 100%; margin-top: 10px;" appearance="outline">
            <mat-label>Website</mat-label>
            <input readonly matInput formControlName="website">
          </mat-form-field>


        </div>

        <div class="row">
          <div><mat-label>Description*</mat-label><br></div>
        <div style="background-color: white; border: 1px solid #5d2041;" [innerHTML]="eventDetails.description">
        </div>
      </div>
        <div class="row">
          <div style="margin-top: 20px ;">
<!-- 
            <label (click)="fileInput.click()" class="uploadimagetext">Image*</label>
            <br>
            <i matTooltip="For a better resolution, we recommend uploading a square picture">Recommended ratio 1:1</i>

            <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
              [uploader]="uploader" />

            <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div> -->
            <div>
              <img class="uploadedimage" src="https://events.globalistic.tech{{eventDetails.images[0].filename}}" ></div>

          </div>
        </div>
      </div>




      <div class="col-md-5 col-md-offset-2">




      </div>

    </div>
  </div>
  <div style="margin-top: 30px;" class="row">
      <div class="col d-flex justify-content-center" >
        <button routerLink='/admin/pendingevents' (click)="acceptEvent()" class="acceptbutton" type="submit">Accept Event</button>
      </div>
      <div class="col d-flex justify-content-center">
        <button  (click)="showCancellation()" class="rejectbutton" type="submit">Reject Event</button>
      </div>
  </div>
</form>
</div>


<div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Reject Event</h4>
        <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
          class="material-icons">highlight_off</i>

      </div>
      <div style="display: inline-block;">

        <div class="modal-body">
          <mat-label>Are you sure you want to reject this event?</mat-label>
          <button (click)="rejectEvent()" class="confirmcancellation">Confirm Rejection</button>
        </div>
        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</div>
